module.exports = __webpack_public_path__ + "static/media/icon-department-store.45672f2e.svg";